import React from 'react';

import AccordionRow from './AccordionRow';
import { HEADERS } from '../../../../../config/constants';
import { getPracticeTimestamp } from '../../../../../helpers/helpers';
import { ATBody as ATBProps, Metric } from '../../types';

const ATBody = ({ 
  sortedPlayers, metrics = {}, className = "", practiceId, expandedAcc = [],
  setMetricCurrentSecond, setExpandedAcc, pinned, theadHeight = 0
} : ATBProps) => {

  const navigateToMetricEvent = (timestamp: number) => {
    setMetricCurrentSecond!(timestamp, practiceId || '');
  };

  const topStickyStyles = (index: number) => {
    let sticky = theadHeight + index * 50;
    for (let i = 0; i < index; i++) {
      const playerId = sortedPlayers[i] ? sortedPlayers[i].playerId : '';
      if (expandedAcc.includes(playerId) && metrics[playerId] && metrics[playerId].length) {
        const stickyDiff = metrics[playerId].length * 40;
        sticky += stickyDiff > 120 ? 120 : stickyDiff;
      }
    }
    return sticky;
  };

  const handleAccordionExpand = (playerId: string) => {
    const unmutedExp = [...expandedAcc];
    const index = unmutedExp.indexOf(playerId);
    if (index > -1) {
      unmutedExp.splice(index, 1);
    } else {
      unmutedExp.push(playerId);
    }
    setExpandedAcc!(unmutedExp);
  };

  // Bug on some devices fix
  const handleAccordionSize = (metrics: Metric) => {
    const metricsLength = metrics.length ? metrics.length * 40 : 0;
    return metricsLength > 120 ? 120 : metricsLength;
  };

  return (
    <>
      {sortedPlayers.map((player, index) => (
        <tr key={player.playerId} className={className} style={pinned? { position: 'sticky', top: topStickyStyles(index), zIndex: 250 } : { position: 'sticky', zIndex: 150 }}>
          <td colSpan={6} className="accordion-row">
            <AccordionRow
              player={player}
              key={player.playerId}
              hasMetrics={Array.isArray(metrics[player.playerId])}
              expandedAcc={expandedAcc.includes(player.playerId)}
              handleAccordionExpand={() => handleAccordionExpand(player.playerId)}
            >
              {metrics[player.playerId] &&
                <table className="nvd-custom-table secondary-table">
                  <tbody style={{ height: handleAccordionSize(metrics[player.playerId]) }}>
                    {metrics[player.playerId].map((met, ind) => (
                      <tr key={ind}>
                        <td 
                          onClick={() => navigateToMetricEvent(met.timestamp)}
                          style={{ paddingLeft: 15, width: 33, paddingRight: 0, cursor: 'pointer' }}
                        >
                          <i className="mdi mdi-play play" />
                        </td>
                        <td style={{ width: 113 }}>{getPracticeTimestamp(0, met.timestamp)}</td>
                        <td className="metric-td">{met.type === HEADERS.accelMed.KEY && <div className="metric-dot" />}</td>
                        <td className="metric-td">{met.type === HEADERS.accelFast.KEY && <div className="metric-dot" />}</td>
                        <td className="metric-td">{met.type === 'decelMed' && <div className="metric-dot" />}</td>
                        <td className="metric-td">{met.type === 'decelFast' && <div className="metric-dot" />}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              }
            </AccordionRow>
          </td>
        </tr>
      ))}
    </>
  );
};

export default ATBody;